import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TilesGroupedByLetter } from '../tile/tile.interface';

@Component({
  selector: 'tile-list',
  templateUrl: './tile-list.component.html',
  styleUrls: ['./tile-list.component.scss'],
})
export class TileListComponent {
  @Input() tilesGroupedByLetter: TilesGroupedByLetter[] = [];
  @Input() tileIdLoading: string;
  @Input() filterToNarrowTranslationCode: string;
  @Output() tileClicked = new EventEmitter();
}
